module.exports = __webpack_public_path__ + "img/45.eac03779.jpg";